import React, { useState } from 'react';

import { Input, InputProps } from 'ui/components/Input';
import { LengthCounter } from 'ui/components/LengthCounter';

import { useDelayChanger } from './hooks';

import { default as InputType } from 'antd/lib/input';

export const DelayedInput = React.forwardRef<InputType, IDelayedInput>((props, ref) => {
  const { name, onChange, delay, value: propsValue } = props;

  const [value, setValue] = useState(propsValue ?? '');
  const [changedValue, setChangedValue] = useState<string | null>(null);

  useDelayChanger(onChange, [name, changedValue], delay);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const v = event.target.value;
    setValue(v);
    setChangedValue(v);
  };

  return (
    <>
      <Input {...props} ref={ref} name={name} value={value} onChange={handleInputChange} />
      {props.maxLength && <LengthCounter value={value} maxLength={props.maxLength} />}
    </>
  );
});

interface IDelayedInput extends Omit<InputProps, 'onChange'> {
  name: string;
  delay?: number;
  onChange: (name: string, value: string) => void;
  value?: string;
}
